import React from "react";
import { useQuery } from "@tanstack/react-query";
import SubmenuTable from "./SubmenuTable";

const Submenu = () => {
  const {
    refetch: subRefetch,
    isLoading,
    isError,
    error,
    isSuccess,
    data: submoduleInfo = [],
  } = useQuery({
    queryKey: ["submoduleInfo"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/moduleLinkSetup`
      );
      const data1 = await res.json();
      const data = await data1.data;
      return data;
    },
  });

  // console.log(moduleInfo);

  return (
    <>
      <SubmenuTable data={submoduleInfo} refetch={subRefetch} />
    </>
  );
};

export default Submenu;
